// extracted by mini-css-extract-plugin
export default {"notfound":"NotFoundPage_notfound__0+RxW"};